var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-touch',{staticClass:"wrapper",on:{"swiperight":_vm.swiperright,"pinchout":_vm.pinchout,"pinchin":_vm.pinchin}},[_c('div',{staticClass:"form-view"},[_c('van-nav-bar',{attrs:{"title":"表单预览","left-text":"合同详情","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('section',[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }